export default __webpack_public_path__ + "d9ef4727cdd1c1612550fdde03590705.png";